/**
 * primary-router.js
 */

import React from 'react';
import {
  Redirect,
  Switch,
  useHistory,
} from "react-router-dom";
import analytics from 'utils/analytics';
import logger from 'utils/logger';
import { forceShowIntercomLauncherIfIntercomOpen } from 'utils/misc';
import { recordListPaths } from 'utils/routing';
import { isIE } from "utils/app-context";
import { renderForMobileContext } from 'utils/app-context';
import { UserContext } from 'contexts/user/user-context';
import { DogsContext } from 'contexts/dogs/dogs-context';
import Route from "routing/route";
import Records from 'routing/routes/records';
import ConfigRouter from 'routing/routes/config';
import UserHistory from 'routing/routes/history';
import AppHome from 'routing/routes/misc/app-home/app-home';
import Terms from 'routing/routes/misc/terms';
import Privacy from 'routing/routes/misc/privacy';
import Stats from 'routing/routes/stats';
import AdminTrackingMap from 'components/tracking/admin-map';
import UserAdmin from 'routing/routes/admin/user-admin';
import ReportMonitor from 'routing/routes/misc/report-monitor';
import ThemeTest from 'components/theme-test';
import IENotSupported from './ie-not-supported';


export default function PrimaryRouter({ props }) {
  const history = useHistory();
  const prevPath = history.location?.state?.prevLocation || '?';
  const currPath = history.location.pathname;
  const { user } = React.useContext(UserContext);
  const { dogs } = React.useContext(DogsContext);


  React.useEffect(() => {
    logger.log('[primary-router.js] URL changed. %s  ==>  %s', prevPath, currPath);
    analytics.trackGA4('pageview', currPath);

    if (user && !user.isImpersonated) {
      window.Intercom("update", {
        app_id: "o89sg5k0",
        email: user.email,
        'Dog count': dogs?.length,
      });
      setTimeout(forceShowIntercomLauncherIfIntercomOpen, 1000);
    }
  }, [user, dogs, prevPath, currPath]);


  return (
    <>
      <Switch location={history.location}>
        {/* records */}
        <Route path={recordListPaths}>
          <Records />

          {/* Give the Intercom help icon space so it doesn't block UI elements, especially on mobile */}
          <div style={{ paddingBottom: 80 }}></div>
        </Route>


        {/* config page routes */}
        {/* <Route path="/(config|myaccount|dogs|billing|training/groups|custom-entries)"> */}
        <Route path={[
          // dog routes
          '/dogs',
          '/:userId(\\d+)/dogs',
          // profile routes
          '/profile', 
          '/:userId(\\d+)/profile', 
          // billing routes
          '/billing',
          '/:userId(\\d+)/billing',
          // others
          '/manage',
          // TODO: support /group for a bit longer until the new /groups route has existed for a while, then remove
          '/group', 
          '/groups',
          '/vaccines',
          '/recovery',
        ]}>
          <ConfigRouter />
        </Route>


        {/* stats page routes */}
        <Route path="/stats">
          <Stats />
        </Route>


        {/* user mod history */}
        <Route path={["/history", "/:userId(\\d+)/history"]}>
          <UserHistory />
        </Route>


        {/* misc routes */}
        {renderForMobileContext() && <Route exact path='/home'><AppHome /></Route>}
        <Route exact path="/terms-of-use"><Terms /></Route>
        <Route exact path="/privacy-policy"><Privacy /></Route>
        <Route exact path="/theme-test"><ThemeTest /></Route>


        {/* admin routes */}
        <Route exact path={`/admin/report-monitor/:filterType?`}><ReportMonitor /></Route>
        <Route exact path={`/admin/tracking/:userId?/:trackType?/:trackId?`}><AdminTrackingMap /></Route>
        <Route exact path={`/admin/user/:userId?`}><UserAdmin /></Route>


        {/* init route */}
        <Route exact path='/'>
          {isIE() && <IENotSupported />}
          {(user.role.isHandler && renderForMobileContext())
            ? <Redirect to='/home' />
            : <Redirect to='/records' />
          }
        </Route>

      </Switch>
    </>
  );
}